module.exports = __webpack_public_path__ + "img/jcb.261bf48e.png";